import { getHost } from "@src/env";

/**
 * Converte uma URL possivelmente absoluta (ex.: `https://admin.fabricca.pro/api/...`,
 * como o contrato do `tts_beep` retorna) no caminho da MESMA origem (`/api/...`).
 * O admin é servido via proxy reverso em `/api` no nginx, então o app nunca faz
 * request cross-origin para `admin.fabricca.pro` (evita CORS e afins).
 */
export function toSameOriginPath(url: string): string {
  const { pathname, search } = new URL(url, getHost());
  return pathname + search;
}
